(() => {
  function mount(scope = document) {
    const button = document.querySelector('#rs-menu-toggle');
    const drawer = scope.querySelector('header-drawer') || document.querySelector('header-drawer');
    if (!button || !drawer || drawer.dataset.rs2Mounted) return;
    drawer.dataset.rs2Mounted = 'true';
    const details = drawer.querySelector('details');
    const summary = details.querySelector('summary');
    const sync = () => {
      const open = drawer.dataset.rs2Open !== undefined ? drawer.dataset.rs2Open === 'true' : details.open;
      button.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
    };
    button.addEventListener('click', event => {
      event.preventDefault();
      if (drawer.dataset.rs2Open === 'true' || (!window.rs2Drawers && details.open)) drawer.closeMenuDrawer(event, button);
      else {
        if (window.rs2Drawers) window.rs2Drawers.open(drawer, button);
        else summary.click();
        if (!window.rs2Drawers) requestAnimationFrame(() => drawer.querySelector('input[type="search"]')?.focus());
      }
    });
    drawer.closest('.header-wrapper')?.addEventListener('keyup', event => {
      if (event.key === 'Escape' && drawer.dataset.rs2Open === 'true') drawer.closeMenuDrawer(event, button);
    });
    drawer.addEventListener('keyup', event => {
      if (event.key === 'Escape' && !window.rs2Drawers) requestAnimationFrame(() => button.focus());
    });
    const observer = new MutationObserver(sync);
    observer.observe(details, {attributes:true, attributeFilter:['open']});
    observer.observe(drawer, {attributes:true, attributeFilter:['data-rs2-open']});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once:true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
